var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2583 13.728L7.99978 2.27344L14.7413 13.728H1.2583ZM7.99978 12.4453C8.25499 12.4453 8.47208 12.3558 8.65106 12.1768C8.83335 11.9946 8.92449 11.7758 8.92449 11.5206C8.92449 11.2654 8.83335 11.0483 8.65106 10.8693C8.47208 10.687 8.25499 10.5959 7.99978 10.5959C7.74457 10.5959 7.52582 10.687 7.34353 10.8693C7.16455 11.0483 7.07506 11.2654 7.07506 11.5206C7.07506 11.7758 7.16455 11.9946 7.34353 12.1768C7.52582 12.3558 7.74457 12.4453 7.99978 12.4453ZM7.39324 9.4723H8.60631L8.6958 6.09162H7.30376L7.39324 9.4723Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/Alert.6421830c645b534a95e1281810411792.svg";
export { ForwardRef as ReactComponent };